import { AssignmentStatus } from '../../Assignment/enums/AssignmentStatus';
import IconContainer from './IconContainer';

interface ReportItemProps {
  icon: React.ReactNode;
  status: AssignmentStatus;
  subtitle: string;
  amount: number;
  title: string;
}

const ReportItem = ({
  icon,
  status,
  amount,
  title,
  subtitle,
}: ReportItemProps) => (
  <div
      className={`
        flex items-center justify-center
        gap-8 lg:gap-12 xl:gap-16
        ${status === AssignmentStatus.PENDING ? 'text-red-500' : 'text-gray-600'}
      `}
    >
      <IconContainer>{icon}</IconContainer>
      <div className="flex flex-col items-center">
        <p className="!font-extrabold text-8xl lg:text-[172px] 2xl:text-[200px]">
          {amount}
        </p>
        <div className="flex items-center gap-2">
          <p className="!font-semibold text-3xl lg:text-4xl 2xl:text-5xl">
            {title}
          </p>
          <span className="text-2xl lg:text-3xl 2xl:text-4xl">
            {subtitle}
          </span>
        </div>
      </div>
    </div>
);

export default ReportItem;
